import i18n from "@brand/certificate/i18n.json";
import mediterranean from "@brand/src/mediterranean.json";

import { verifyBaseUrl } from "./config";
import type { Locale, SurfaceRecord } from "./types";

export const SAMPLE_TOKEN = "b7f1c9a4e2d84f6a8c15";

const allColors = mediterranean.groups.flatMap((g) => g.colors);

/** Demo record — used when the API is unreachable, so the UI is always viewable. */
export function createSampleRecord(locale: Locale): SurfaceRecord {
  const d = i18n[locale];
  const system = (d.system as Record<string, string>);
  const color = allColors.find((c) => c.name === "Terra Andalusa");

  return {
    serial: "VRS-2026-ES0042",
    revision: 1,
    issuedAt: "06/03/2026",
    status: "valid",
    reviewer: "Marco Bellini",
    insurancePolicyRef: null,

    project: {
      name: "Hotel Boutique Madrid",
      client: "Hotel Boutique Madrid S.L.",
      siteAddress: "Calle de Alcalá 45",
      city: "Madrid, ES",
    },

    surface: {
      name: "Lobby & reception floor",
      m2: "186,00",
      type: "floor",
      typeLabel: d.surfaceType.floor,
      location: locale === "it" ? "Piano terra" : "Ground floor",
      systemLabel: [system.FLEX, system.R10R12].join(" · "),
      finish: "spatolato",
      finishLabel: d.finish.spatolato,
      colorRef: "Terra Andalusa",
      colorSwatch: color?.hex ?? null,
      customDesign: null,
    },

    lots: [
      { layer: "Primer", productName: "Versus Anchor P1", lotNumber: "L-24118" },
      { layer: "Geo-matrix", productName: "Versus Matrix FLEX", lotNumber: "L-24203" },
      { layer: "Sealer", productName: "Versus Top Coat 2K", lotNumber: "L-24207" },
    ],

    applicator: {
      companyName: "Atelier Superfici S.r.l.",
      academyLevel: "gold",
      academyLabel: d.academy.gold,
      patentinoNumber: "VRS-AC-2026-0312",
    },

    dates: { installed: "18/02/2026", collaudo: "04/03/2026" },

    warranty: [
      { kind: "adhesion", label: d.warranty.adhesion, years: 10, expiresAt: "04/03/2036", status: "active" },
      { kind: "anti_crack", label: d.warranty.anti_crack, years: 10, expiresAt: "04/03/2036", status: "active" },
      { kind: "uv", label: d.warranty.uv, years: 5, expiresAt: "04/03/2031", status: "active" },
      { kind: "waterproof", label: d.warranty.waterproof, years: 5, expiresAt: "04/03/2031", status: "active" },
    ],

    maintenance: { last: "04/03/2027", next: "04/03/2028" },

    verifyUrl: `${verifyBaseUrl}/${SAMPLE_TOKEN}`,
  };
}
